function isEdge() {
    return navigator.userAgent.toLowerCase().indexOf("edge") !== -1;
}

export function isInternetExplorer6() {
    return navigator.userAgent.toLowerCase().indexOf("msie 6") !== -1;
}

export function isInternetExplorer7() {
    return navigator.userAgent.toLowerCase().indexOf("msie 7") !== -1;
}

export function isInternetExplorer8() {
    return navigator.userAgent.toLowerCase().indexOf("msie 8") !== -1;
}

export function isFireFox() {
    return navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
}

export function isChrome() {
    return navigator.userAgent.toLowerCase().indexOf("chrome") !== -1;
}

function isMobile() {
    return navigator.userAgent.toLowerCase().indexOf("mobi") !== -1;
}

export function isSmallScreen() {
    return window.matchMedia('(max-width: 1024px)').matches;
}

export const mediumScreenQuery = window.matchMedia('(max-width: 1024px)');
